// Implements: F-IDN-010, F-IDN-015
/**
 * The DB-IP Lite attribution its CC BY 4.0 licence asks for, under every table that shows a place
 * read from an address (owner decision: "Ubicación por IP de DB-IP.com" with a link).
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import shared from "./account.module.css";

export const DBIP_URL = "https://db-ip.com";
const DBIP_NAME = "DB-IP.com";

export function GeoAttribution(): ReactElement {
  const { t } = useTranslation();
  return (
    <p className={shared.help}>
      {t("account.geo.attribution")}{" "}
      <a className={shared.link} href={DBIP_URL} target="_blank" rel="noopener noreferrer">
        {DBIP_NAME}
      </a>
    </p>
  );
}
